import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as createVideoConferenceCall from "./createVideoConferenceCall";
import * as retrieveVideoConferenceCallLinks from "./retrieveVideoConferenceCallLinks";

const initialState: State = {
  createVideoConferenceCall: createVideoConferenceCall.initialState,
  retrieveVideoConferenceCallLinks:
    retrieveVideoConferenceCallLinks.initialState,
};

const reduceState = combineStateReducer(initialState, {
  createVideoConferenceCall: createVideoConferenceCall.reduceState,
  retrieveVideoConferenceCallLinks:
    retrieveVideoConferenceCallLinks.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...createVideoConferenceCall.createSelector(
      () => getState().createVideoConferenceCall,
    ),
    ...retrieveVideoConferenceCallLinks.createSelector(
      () => getState().retrieveVideoConferenceCallLinks,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
